import { render } from "./subTitle.vue?vue&type=template&id=37f56a26&scoped=true"
import script from "./subTitle.vue?vue&type=script&lang=js"
export * from "./subTitle.vue?vue&type=script&lang=js"

import "./subTitle.vue?vue&type=style&index=0&id=37f56a26&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f56a26"]])

export default __exports__